function timesheetRegisterDialog () {
  return {
    restrict: 'E',
    templateUrl: '/workflow/dialogs/timesheet-register/timesheet-register-dialog.html?$$REVISION$$'
  }
}

export { timesheetRegisterDialog }
